import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";

import { CptInput } from "custom-models";

type CPTDigitalLineProps = {
  index?: number;
  cpt: CptInput;
};

const CPTDigitalLine = ({ cpt }: CPTDigitalLineProps) => {
  return (
    <div className="Sidebar__group-container CPTInputLine CPTInputLine--Digital">
      <label className="Sidebar__group-container">
        +{cpt.code?.code}({cpt.quantity})&nbsp;
        <FontAwesomeIcon
          icon="circle-question"
          data-tip
          data-for="digitization-code-explainer"
          color="var(--blue50)"
        />
      </label>
      <ReactTooltip
        id="digitization-code-explainer"
        type="light"
        backgroundColor="var(--lightGrey)"
        place="bottom"
      >
        New CPT codes for digitization procedures are added automatically
      </ReactTooltip>
    </div>
  );
};

export default CPTDigitalLine;
